import { render, staticRenderFns } from "./DriverFormDetail.vue?vue&type=template&id=6db1c53e&scoped=true"
import script from "./DriverFormDetail.vue?vue&type=script&lang=js"
export * from "./DriverFormDetail.vue?vue&type=script&lang=js"
import style0 from "./DriverFormDetail.vue?vue&type=style&index=0&id=6db1c53e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db1c53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db1c53e')) {
      api.createRecord('6db1c53e', component.options)
    } else {
      api.reload('6db1c53e', component.options)
    }
    module.hot.accept("./DriverFormDetail.vue?vue&type=template&id=6db1c53e&scoped=true", function () {
      api.rerender('6db1c53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DriverFormDetail.vue"
export default component.exports